module.exports = __webpack_public_path__ + "media/images/flags/1x1/nga-6309471a923bc3513dce13ec384a2c04.svg";